<div class="chip-list-wrapper">
  <mat-form-field class="chip-list" floatLabel="always">
    <mat-label>{{placeholder}}</mat-label>
    <mat-select [multiple]="true">
      <mat-select-trigger>
        <span class="chips-trigger-text">{{selectedItems.length ? ' ' : ''}}</span>
      </mat-select-trigger>
      <mat-option #allSelected>
        Select all
      </mat-option>
      <mat-option *ngFor="let item of data"
                  [value]="item.key"
                  [disabled]="item.disabled"
                  matTooltip="{{item.disabledTooltip}}">
        {{item.displayText}}
      </mat-option>
    </mat-select>
    <div class="chips-inline" *ngIf="selectedItems.length > 0">
      <span class="custom-chip" *ngFor="let value of selectedItems">
        {{value.displayText}}
        <mat-icon class="custom-chip-remove" *ngIf="removable" (click)="remove(value)">cancel</mat-icon>
      </span>
    </div>
  </mat-form-field>
  <ng-content></ng-content>
</div>
